(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mobile-menu-link"] && !Shopify.designMode) return;
  try {
    /* See the .mobile-menu-link__details--closing rule in this block's stylesheet tag for why
     closing specifically (not opening) needs help: native <details> hides its non-summary
     children the instant [open] is removed, before any transition on them has a chance to run, and
     only Chrome's own ::details-content element is exempted from that - an ordinary classed <div>
     like ours isn't, in any browser. Delaying the actual `open = false` until the shrink has
     visibly finished - via a temporary class that forces the row back to 0fr while [open] is still
     present - reproduces that exemption by hand. Delegated on `document`, not a per-instance
     listener, since this block can render many times on one page and the listener only needs to
     exist once regardless. */
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.mobile-menu-link__summary');
    if (!summary) return;

    const details = summary.closest('.mobile-menu-link__details');
    if (!details || !details.open) return;

    const content = details.querySelector(':scope > .details-content');
    if (!content) return;

    event.preventDefault();
    details.classList.add('mobile-menu-link__details--closing');

    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      content.removeEventListener('transitionend', onTransitionEnd);
      clearTimeout(fallback);
      details.classList.remove('mobile-menu-link__details--closing');
      details.open = false;
    };
    const onTransitionEnd = (transitionEvent) => {
      if (transitionEvent.target === content && transitionEvent.propertyName === 'grid-template-rows') {
        finish();
      }
    };
    content.addEventListener('transitionend', onTransitionEnd);
    // Safety net for prefers-reduced-motion (a zero-duration transition never fires transitionend)
    // and any other case where the event is missed (tab backgrounded mid-animation, etc.).
    const fallback = setTimeout(finish, 400);
  });
  } catch(e) { console.error(e); }
})();

})();
